var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsPe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Flag_of_Peru",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 600,
    width: 900,
    fill: "#D91023",
    x: 0,
    y: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 600,
    width: 300,
    fill: "white",
    x: 300,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsPe);
export default __webpack_public_path__ + "static/media/es-PE.046e4002713c59c4a280cfd97f16a0b9.svg";
export { ForwardRef as ReactComponent };